import { useQuery } from "react-query";

import { emailTemplateQueryKeys } from "./queryKeys";
import useApiHelper from "../../services/useApiHelper";
import { IEmailTemplate } from "../../models/emailTemplates/EmailTemplate";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";

export default function useEmailTemplates() {
  const staleTime = 10000;
  const { get } = useApiHelper();

  const emailTemplates = useQuery(
    emailTemplateQueryKeys.all(),
    () =>
      get(`/emailtemplate`) as unknown as IDefaultResponseWithData<
        IEmailTemplate[]
      >,
    {
      staleTime: staleTime,
    }
  );

  return {
    emailTemplates,
  };
}
